import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";

export function SchoolIntroSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  const imageData = [
    {
      src: images.childrenOutdoor,
      alt: "孩子们在操场",
      text: "疗愈心灵",
    },
    {
      src: images.childrenIndoor,
      alt: "孩子们在教室",
      text: "教育赋能",
    },
  ];

  return (
    <section
      ref={ref}
      className="relative min-h-screen w-full flex items-start justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50 pt-24 pb-32 px-6"
    >
      <div className="max-w-7xl w-full">
        {/* 标题区域 - 和善行足迹一样的样式 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ scaleX: 0 }}
            animate={isInView ? { scaleX: 1 } : { scaleX: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="h-1 w-24 bg-blue-600 mx-auto mb-8"
          />
          <h2 className="text-zinc-800 text-3xl md:text-5xl">国际人道战争儿童学校</h2>
        </motion.div>

        {/* 两张照片并列 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {imageData.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={
                isInView
                  ? { opacity: 1, y: 0 }
                  : { opacity: 0, y: 50 }
              }
              transition={{ duration: 0.8, delay: 0.4 + index * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="group relative"
            >
              <div className="relative aspect-[3/4] overflow-hidden rounded-3xl shadow-2xl">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                />
                
                {/* 渐变遮罩 */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                
                {/* 文字内容 */}
                <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-10">
                  <motion.h3
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6, delay: 0.6 + index * 0.15 }}
                    className="text-white text-xl md:text-3xl lg:text-4xl mb-4 transition-transform duration-500 group-hover:scale-105"
                  >
                    {image.text}
                  </motion.h3>
                  
                  {/* 装饰线 */}
                  <motion.div
                    initial={{ scaleX: 0 }}
                    animate={isInView ? { scaleX: 1 } : { scaleX: 0 }}
                    transition={{ duration: 0.8, delay: 0.8 + index * 0.15 }}
                    className="h-1 bg-white origin-left group-hover:bg-blue-400 transition-colors duration-500"
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

